import React from 'react'

//import styles from './Label.module.css'

const HangupLabel = ({
  ai: {
    attributes: { Location },
  },
}) => (
  <div>
    <div>{Location || '[BLANK]'}</div>
  </div>
)

export default HangupLabel
